import { render, staticRenderFns } from "./DiscountSvg.vue?vue&type=template&id=29e48d1a&"
import script from "./DiscountSvg.vue?vue&type=script&lang=js&"
export * from "./DiscountSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports